import GridContainer, { GridContainerProps } from "@cahaba/MobiusOverrides/GridContainer";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";

import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import parse from "html-react-parser";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsInformationTabsStyles {
    badgeContainer?: GridContainerProps;
    badgeGridItem?: GridItemProps;
    badgeImage?: LazyImageProps;
}

export const specificationsStyles: ProductDetailsInformationTabsStyles = {
    badgeContainer: {
        gap: 15,
    },
    badgeGridItem: {
        width: [3, 2, 2, 1, 1],
    },
    badgeImage: {
        css: css`
            width: 100%;
            height: 100%;
            max-width: 48px;
            max-height: 48px;
            cursor: pointer;
            justify-content: flex-start;
            img {
                max-width: 64px;
                max-height: 64px;
                padding: 3px;
            }
        `,
    },
};

const styles = specificationsStyles;

const ProductDetailsBadgeArray: React.FC<Props> = ({ product: { specifications } }) => {
    const specificationsWithProductBadge = specifications?.filter(specification =>
        specification.name.startsWith("Badge_"),
    );
    const renderingBadges = specificationsWithProductBadge && specificationsWithProductBadge.length > 0;

    if (renderingBadges) {
        return (
            <GridContainer className="badgeGrid" {...styles.badgeContainer}>
                {specifications
                    ?.filter(specification => specification.name.startsWith("Badge_"))
                    ?.map((spec, index) => {
                        return parse(spec.htmlContent, {
                            replace: node => {
                                const { name, children } = node;
                                if (name === "html" && children !== undefined && children.length > 0) {
                                    const bodyElement = children?.filter(
                                        (child: any) => child.name && child.name === "body",
                                    );

                                    if (
                                        bodyElement.length > 0 &&
                                        bodyElement[0].children &&
                                        bodyElement[0].children.length > 0 &&
                                        bodyElement[0].children[0].type === "text" &&
                                        bodyElement[0].children[0].data !== undefined
                                    ) {
                                        const badgeUrl = bodyElement[0].children[0].data;
                                        return (
                                            <GridItem key={`badgeImage${index}`} {...styles.badgeGridItem}>
                                                <LazyImage
                                                    {...styles.badgeImage}
                                                    src={badgeUrl}
                                                    altText="Product badge image"
                                                />
                                            </GridItem>
                                        );
                                    }
                                    return <></>;
                                }
                            },
                        });
                    })}
            </GridContainer>
        );
    }

    return null;
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsBadgeArray),
    definition: {
        displayName: "Product Badge Array",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [],
    },
};

export default widgetModule;
